import React, {FC} from 'react';

import {EventStatus, Sport, TeamInfo} from 'utils/types';

import './styles.scss';

import teamHomeLogoFallback from 'assets/img/team-home-logo-placeholder.png'; // TODO: svg and colorize
import teamAwayLogoFallback from 'assets/img/team-away-logo-placeholder.png'; // TODO: svg and colorize

interface Props {
  teams: {home: TeamInfo; away: TeamInfo};
  scores: {home: number; away: number};
  isApp?: boolean;
  status?: string;
  minute?: number;
  date?: Date;
  sport?: Sport;
  stoppageTime?: number;
  matchStatus?: string;
  visible?: boolean;
}

const HeaderMini: FC<Props> = ({
  teams,
  scores,
  minute,
  date,
  sport,
  stoppageTime,
  status,
  matchStatus,
  visible = false,
  isApp = false,
}: Props) => {
  return (
    <div
      className={`HeaderMini ${visible ? 'HeaderMini--visible' : ''} ${
        isApp ? 'HeaderMini--app' : ''
      }`}
    >
      <div className="HeaderMini__spacer-left" />
      <section className="HeaderMini__scoreboard">
        <h2 className="HeaderMini__teamName">{teams.home.shortName}</h2>
        <img
          className="HeaderMini__teamLogo"
          // src={teams.home.imageUrl || teamHomeLogoFallback}
          src={sport === Sport.TENNIS ? teamHomeLogoFallback : (teams.home.imageUrl || teamHomeLogoFallback)}
          width="40"
          height="40"
          alt={teams.home.name}
        />
        <span className="HeaderMini__teamScore">{scores.home ?? '-'}</span>
        <span className="HeaderMini__matchStatus">
        {// eslint-disable-next-line no-nested-ternary
          (status as EventStatus) === EventStatus.NOT_STARTED ? (
            <div className="HeaderMini__date">
              <span className="HeaderMini__day">
                {date?.getDate()} {date?.toLocaleString('el-GR', {month: 'short'})}
              </span>
              <span className="HeaderMini__time">{`${date?.getHours()}:${date
                ?.getMinutes()
                .toString()
                .padStart(2, '0')}`}</span>
            </div>
          ) : (status as EventStatus) === EventStatus.LIVE &&
        minute !== null &&
        minute !== 0 &&
        minute !== undefined &&
        matchStatus !== 'ΗΜΙ' &&
        matchStatus !== 'BREAK'
          ? `${minute}${stoppageTime ? ` + ${stoppageTime}` : ''}'`
          : matchStatus}
        </span>
        <span className="HeaderMini__teamScore">{scores.away ?? '-'}</span>
        <img
          className="HeaderMini__teamLogo"
          // src={teams.away.imageUrl || teamAwayLogoFallback}
          src={sport === Sport.TENNIS ? teamAwayLogoFallback : (teams.away.imageUrl || teamAwayLogoFallback)}
          width="40"
          height="40"
          alt={teams.away.name}
        />
        <h2 className="HeaderMini__teamName">{teams.away.shortName}</h2>
      </section>
      <div className="HeaderMini__spacer-right" />
    </div>
  );
};

export default HeaderMini;
